export enum EducationDegree {
  Master = 'MASTER',
  Bachelor = 'BACHELOR',
  PhD = 'PHD',
}

export enum EducationType {
  Degree = 'DEGREE',
  FieldOfStudy = 'FIELD_OF_STUDY',
}
